module.exports = __webpack_public_path__ + "img/openstack.53df350.svg";